export const FLAT_AMOUNT = 'FLAT_AMOUNT';
export const PERCENTAGE = 'PERCENTAGE';
export const AWARD_TYPE_NEED = 'NEED';
export const AWARD_TYPE_AGI = 'AGI';
export const AWARD_TYPE_SAI = 'SAI';

export const ARCHIVE_TOAST_TITLE = 'Model was archived';
export const ARCHIVE_TOAST_MESSAGE = 'You can find it in Archived section.';
export const RESTORE_TOAST_TITLE = 'Model was restored';
export const RESTORE_TOAST_MESSAGE = 'It is available in all models list.';

export const MODELS_LIST_TAB = {
  ALL: 'all',
  ARCHIVED: 'archived',
} as const satisfies Record<string, string>;

export type ModelsListTab =
  (typeof MODELS_LIST_TAB)[keyof typeof MODELS_LIST_TAB];
